import * as React from "react";
import {
  Box,
  Typography,
  Chip,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoafCard from "../components/LoafCard";
import {
  Code,
  Api,
  Storage,
  Psychology,
  Speed,
  Security,
  Analytics,
  CloudUpload,
  Search,
  Memory,
  Link,
  Dashboard,
  AutoAwesome,
  Rocket,
  Build,
  Layers,
  Timeline,
  FilterList,
  Insights,
  Chat,
  Settings,
  DataUsage,
  CloudSync,
  Engineering,
  Architecture,
  SmartToy,
  GroupWork,
  Assignment,
  Update,
  Tune,
  Transform,
  BugReport,
  CreateNewFolder,
  Launch,
  Polyline,
} from "@mui/icons-material";

// Function to get appropriate icon for description points with better variety
const getDescriptionIcon = (description, index = 0) => {
  const text = description.toLowerCase();

  // Define color palette for better distribution
  const colors = [
    "#4db6ac", // teal
    "#ffb74d", // amber
    "#ba68c8", // purple
    "#81c784", // green
    "#f06292", // pink
    "#ff8a65", // orange
    "#64b5f6", // blue
    "#9575cd", // deep purple
    "#4fc3f7", // light blue
    "#aed581", // light green
    "#ffab91", // deep orange
    "#f48fb1", // light pink
  ];

  // More specific matching to avoid repetition - most specific first
  if (text.includes("prompt engineering") || text.includes("advanced prompt")) {
    return <AutoAwesome sx={{ fontSize: 16, color: colors[1] }} />;
  }
  if (
    text.includes("template management") ||
    text.includes("template sharing")
  ) {
    return <GroupWork sx={{ fontSize: 16, color: colors[4] }} />;
  }
  if (
    text.includes("prompt validation") ||
    text.includes("enhancement suggestions")
  ) {
    return <BugReport sx={{ fontSize: 16, color: colors[7] }} />;
  }
  if (text.includes("ai-powered") && text.includes("optimization")) {
    return <Tune sx={{ fontSize: 16, color: colors[3] }} />;
  }
  if (text.includes("ai-powered") && text.includes("analytics")) {
    return <Psychology sx={{ fontSize: 16, color: colors[0] }} />;
  }
  if (text.includes("gemini ai") && text.includes("integrated")) {
    return <Link sx={{ fontSize: 16, color: colors[9] }} />;
  }
  if (text.includes("fastapi") || text.includes("backend")) {
    return <Api sx={{ fontSize: 16, color: colors[2] }} />;
  }
  if (
    text.includes("optimization") ||
    text.includes("performance") ||
    text.includes("testing")
  ) {
    return <Tune sx={{ fontSize: 16, color: colors[3] }} />;
  }
  if (
    text.includes("sharing") ||
    text.includes("collaborative") ||
    text.includes("marketplace")
  ) {
    return <GroupWork sx={{ fontSize: 16, color: colors[4] }} />;
  }
  if (
    text.includes("export") ||
    text.includes("import") ||
    text.includes("format")
  ) {
    return <Transform sx={{ fontSize: 16, color: colors[5] }} />;
  }
  if (text.includes("real-time") || text.includes("streaming")) {
    return <Speed sx={{ fontSize: 16, color: colors[6] }} />;
  }
  if (
    text.includes("conversational") ||
    text.includes("chat") ||
    text.includes("assistant")
  ) {
    return <Chat sx={{ fontSize: 16, color: colors[7] }} />;
  }
  if (
    text.includes("multi-turn") ||
    text.includes("memory") ||
    text.includes("context")
  ) {
    return <Memory sx={{ fontSize: 16, color: colors[8] }} />;
  }
  if (
    text.includes("integration") ||
    text.includes("integrates") ||
    text.includes("google")
  ) {
    return <Link sx={{ fontSize: 16, color: colors[9] }} />;
  }
  if (text.includes("workflow") || text.includes("automation")) {
    return <Settings sx={{ fontSize: 16, color: colors[10] }} />;
  }
  if (text.includes("rendering") || text.includes("markdown")) {
    return <Code sx={{ fontSize: 16, color: colors[11] }} />;
  }
  if (text.includes("analytics") || text.includes("platform")) {
    return <Analytics sx={{ fontSize: 16, color: colors[0] }} />;
  }
  if (text.includes("pipeline") || text.includes("orchestrated")) {
    return <Timeline sx={{ fontSize: 16, color: colors[1] }} />;
  }
  if (
    text.includes("sql") ||
    text.includes("query") ||
    text.includes("validation")
  ) {
    return <DataUsage sx={{ fontSize: 16, color: colors[2] }} />;
  }
  if (text.includes("insight") || text.includes("visualization")) {
    return <Insights sx={{ fontSize: 16, color: colors[3] }} />;
  }
  if (text.includes("structured") || text.includes("threading")) {
    return <Architecture sx={{ fontSize: 16, color: colors[4] }} />;
  }
  if (
    text.includes("auth") ||
    text.includes("jwt") ||
    text.includes("role-based")
  ) {
    return <Security sx={{ fontSize: 16, color: colors[5] }} />;
  }
  if (
    text.includes("rate limiting") ||
    text.includes("quota") ||
    text.includes("usage")
  ) {
    return <FilterList sx={{ fontSize: 16, color: colors[6] }} />;
  }
  if (
    text.includes("cost") ||
    text.includes("tracker") ||
    text.includes("breakdown")
  ) {
    return <BugReport sx={{ fontSize: 16, color: colors[7] }} />;
  }
  if (
    text.includes("reports") ||
    text.includes("charts") ||
    text.includes("summaries")
  ) {
    return <Assignment sx={{ fontSize: 16, color: colors[8] }} />;
  }
  if (
    text.includes("semantic") ||
    text.includes("search") ||
    text.includes("engine")
  ) {
    return <Search sx={{ fontSize: 16, color: colors[9] }} />;
  }
  if (
    text.includes("document") ||
    text.includes("upload") ||
    text.includes("pdf")
  ) {
    return <Polyline sx={{ fontSize: 16, color: colors[10] }} />;
  }
  if (
    text.includes("langchain") ||
    text.includes("pgvector") ||
    text.includes("chromadb") ||
    text.includes("vector")
  ) {
    return <Layers sx={{ fontSize: 16, color: colors[11] }} />;
  }
  if (
    text.includes("answers") ||
    text.includes("q&a") ||
    text.includes("context-aware")
  ) {
    return <SmartToy sx={{ fontSize: 16, color: colors[0] }} />;
  }
  if (
    text.includes("similarity") ||
    text.includes("metadata") ||
    text.includes("filtering")
  ) {
    return <Tune sx={{ fontSize: 16, color: colors[1] }} />;
  }
  if (
    text.includes("follow-ups") ||
    text.includes("tracking") ||
    text.includes("logging")
  ) {
    return <Update sx={{ fontSize: 16, color: colors[2] }} />;
  }
  if (
    text.includes("parsing") ||
    text.includes("extraction") ||
    text.includes("pipeline")
  ) {
    return <Engineering sx={{ fontSize: 16, color: colors[3] }} />;
  }
  if (
    text.includes("sop") ||
    text.includes("generation") ||
    text.includes("notes")
  ) {
    return <CreateNewFolder sx={{ fontSize: 16, color: colors[4] }} />;
  }
  if (text.includes("embeddings") || text.includes("structured")) {
    return <Build sx={{ fontSize: 16, color: colors[5] }} />;
  }
  if (
    text.includes("pinecone") ||
    text.includes("pgvector") ||
    text.includes("supabase")
  ) {
    return <CloudSync sx={{ fontSize: 16, color: colors[6] }} />;
  }
  if (
    text.includes("tag-based") ||
    text.includes("organization") ||
    text.includes("workflows")
  ) {
    return <Dashboard sx={{ fontSize: 16, color: colors[7] }} />;
  }
  if (
    text.includes("pwa") ||
    text.includes("interface") ||
    text.includes("react")
  ) {
    return <Rocket sx={{ fontSize: 16, color: colors[8] }} />;
  }
  if (
    text.includes("version control") ||
    text.includes("metadata") ||
    text.includes("tracking")
  ) {
    return <Storage sx={{ fontSize: 16, color: colors[9] }} />;
  }
  if (
    text.includes("topic") ||
    text.includes("date") ||
    text.includes("filtering")
  ) {
    return <FilterList sx={{ fontSize: 16, color: colors[10] }} />;
  }

  // Fallback with rotating colors based on index for remaining variety
  const fallbackColors = [
    colors[11],
    colors[0],
    colors[3],
    colors[6],
    colors[9],
  ];
  return (
    <Code
      sx={{
        fontSize: 16,
        color: fallbackColors[index % fallbackColors.length],
      }}
    />
  );
};

// Function to get color-coded chips for tech stack
const getChipColor = (techName) => {
  const tech = techName.toLowerCase();

  // Frontend - Blue
  if (
    tech.includes("react") ||
    tech.includes("material ui") ||
    tech.includes("next")
  ) {
    return "#64b5f6";
  }

  // Backend - Orange
  if (
    tech.includes("fastapi") ||
    tech.includes("python") ||
    tech.includes("ruby") ||
    tech.includes("node")
  ) {
    return "#ff8a65";
  }

  // Database - Purple
  if (
    tech.includes("postgres") ||
    tech.includes("sqlite") ||
    tech.includes("mysql")
  ) {
    return "#ba68c8";
  }

  // Vector DB/CLI Tool - Green
  if (
    tech.includes("chromadb") ||
    tech.includes("pinecone") ||
    tech.includes("pgvector") ||
    tech.includes("embeddings") ||
    tech.includes("cli")
  ) {
    return "#81c784";
  }

  // AI - Teal
  if (
    tech.includes("gemini") ||
    tech.includes("openai") ||
    tech.includes("anthropic") ||
    tech.includes("hugging face") ||
    tech.includes("grok") ||
    tech.includes("claude") ||
    tech.includes("grok") ||


    tech.includes("genai") ||

    tech.includes("nlp")
  ) {
    return "#4db6ac";
  }

  // Blockchain/Crypto - Gold
  if (
    tech.includes("blockchain") ||
    tech.includes("cryptography") ||
    tech.includes("crypto")
  ) {
    return "#ffb74d";
  }

  // Other - Pink
  return "#f06292";
};

// Put your project cards' content here
const items = [
  {
    key: "prism",
    title: "prism",
    url: "https://prism.loafstack.dev",
    tech: [
      "Chrome Extension",
      "React 19",
      "Material UI",
      "FastAPI",
      "PostgreSQL",
      "Pinecone",
      "scikit-learn",
      "Gemini AI"
    ],
    bullets: [
      "Chrome extension learns EMR workflows from real clicks, then turns them into approved step-by-step guides",
      "Typed text never leaves the browser: only whether a field has a value and its length",
      "Regex PII redaction in the extension, plus server-side sanitizing of URLs, titles and sensitive fields",
      "Each event is embedded with Gemini (768 dims) and stored in Pinecone for semantic search",
      "DBSCAN clustering with a KMeans fallback finds the workflows an organization repeats",
      "Gemini writes each cluster up as a named protocol with purpose, steps and required fields",
      "Admins review, edit, regenerate and approve protocols in the React dashboard",
      "Interactive 3D force graph shows discovered workflows and how protocols relate",
      "Protocol search (Ctrl+Shift+K) opens a side panel of approved protocols that filters as you type",
      "Guided steps find each element on the EMR page, highlight it and draw a path to it",
      "AI chart notes (Ctrl+Shift+D) pick out vitals, meds and labs you visited and draft a clinical note",
      "Status bar with chart timer, recent clicks, tips and role-based actions",
      "Idle nudges at 5, 10, 15, 20 and 25 minutes of chart time keep charting on track",
      "Similar-action search ranks recorded actions by meaning across the organization",
      "Workflow analytics flag rapid clicks, navigation loops, abandoned and duplicate work",
      "Coaching and leadership views with efficiency, risk score and call analytics across five JWT roles"
    ],
  },
  {
    key: "spectra",
    title: "spectra",
    url: "https://spectra.loafstack.dev",
    tech: [
      "React 19",
      "Material UI",
      "FastAPI",
      "SQLAlchemy",
      "PostgreSQL",
      "n8n",
      "Gemini AI"
    ],
    bullets: [
      "Chart workspace for monthly CCM, RPM, BHI and PCM care-coordination calls: before, during and after",
      "Patient chart with about 35 editable cards and ICD-10, CPT and LOINC pickers",
      "Drag-and-drop card layout across five columns, remembered per patient",
      "Program Lens highlights the cards each program needs, with RPM compliance against 16 readings a month",
      "Rules-based pre-call agenda ranks P0 to P3 items, each linked to the chart card it came from",
      "Last call's coordinator next steps come back as top-priority agenda items",
      "Sticky call timer turns amber at 15 minutes and red at 20",
      "Training quizzes on escalation and workflows with server-side scoring",
      "Gemini drafts encounter notes and next steps from the live form and the full chart",
      "Notes prompt forbids inventing actions or values, with a template fallback if the AI call fails",
      "SOP assistant answers workflow questions from 20 SOPs, cites its sources and tailors to the open patient",
      "AI care-gap tasks suggest preventive care and skip duplicates",
      "n8n webhook with eight actions, including documenting encounters from transcripts or Prism click logs",
      "One shared chart context feeds every AI feature across a 41-table Postgres data model"
    ],
  },
  // {
  //   key: "data",
  //   title: "data",
  //   url: "https://dataloafs.com",
  //   tech: ["React", "FastAPI", "Python", "PostgreSQL", "SQLAlchemy", "JWT Auth", "Google Gemini"],
  //   bullets: [
  //     "Gemini converts natural language into SQL queries",
  //     "Orchestrated pipeline: Intent to SQL to Visualization",
  //     "Structured memory enables multi-turn question AI threading",
  //     "Role-based JWT auth with Free and Admin tiers",
  //     "Dynamic rate limiting with real-time usage tracking",
  //     "AI cost tracker with token logs per query",
  //     "Generate HTML reports with charts and summaries",
  //   ],
  // },
  // {
  //   key: "echochamber",
  //   title: "echo",
  //   url: "https://echo.loafstack.dev",
  //   tech: [
  //     "React 19",
  //     "ReactFlow",
  //     "FastAPI",
  //     "Python",
  //     "Google Gemini",
  //     "OpenAI GPT",
  //     "Anthropic Claude"
  //   ],
  //   bullets: [
  //     "Multi-agent orchestration with smart AI fallbacks",
  //     "Real-time streaming ReactFlow diagrams with sub-second updates",
  //     "Healthcare transcript analysis for CCM/RPM/BHI compliance",
  //     "Interactive protocol generation builds executable workflows",
  //     "High-performance FastAPI supports 1000+ concurrent streams",
  //     "Production-ready secure APIs with rate limits",
  //     "Multi-format parser with PDF extract and drag-drop",
  //   ],
  // },
  // {
  //   key: "whisk",
  //   title: "whisk",
  //   url: "https://whisk.loafstack.dev",
  //   tech: [
  //     "React",
  //     "FastAPI",
  //     "Python",
  //     "Pinecone",
  //     "OpenAI API",
  //     "Anthropic API",
  //     "Embeddings",
  //     "3D Viz"
  //   ],
  //   bullets: [
  //     "Real-time streaming multi-agent AI workflow engine",
  //     "Server-Sent Events for character-by-character streaming",
  //     "Three-agent pipeline: Retriever, Planner, Judge orchestration",
  //     "Pinecone vector database for semantic memory",
  //     "A/B testing arena compares GPT-4o vs mini",
  //     "3D visualization of embeddings using principal components analysis",
  //     "Multi-modal analysis: images, PDFs, URLs with vision",
  //   ],
  // },
];

export default function Projects() {
  const navigate = useNavigate();

  const handleCardClick = (url) => {
    // Check if it's an internal route (starts with /)
    if (url.startsWith("/")) {
      navigate(url);
    } else {
      // External link - open in new tab
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const handleDemoClick = (e, demoUrl) => {
    e.stopPropagation(); // Prevent card click

    if (!demoUrl) {
      console.warn("Demo URL missing for project card");
      return;
    }

    handleCardClick(demoUrl);
  };

  // Group items
  const featured = items.filter((it) => ["prism", "spectra"].includes(it.key));

  return (
    <Box sx={{
      minHeight: "100vh",
      width: "100vw",
      minWidth: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      px: { xs: 2, sm: 3, md: 4 },
      py: { xs: 3, md: 4 },
      overflow: "auto",
      "&::-webkit-scrollbar": { display: "none" },
      "&::-webkit-scrollbar-track": { display: "none" },
      "&::-webkit-scrollbar-thumb": { display: "none" },
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      position: "relative"
    }}>
      <Box sx={{
        width: "100%",
        maxWidth: "1400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <Box sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          justifyContent: "center",
          alignItems: "stretch",
          gap: { xs: 3, md: 4 },
          mb: 6,
          width: "100%",
          "& > *": {
            minWidth: { xs: "100%", lg: "calc(50% - 16px)" },
            maxWidth: { xs: "100%", lg: "calc(50% - 16px)" },
            height: { xs: "auto", lg: "1100px" },
            flex: { lg: "0 0 auto" }
          }
        }}>
          {featured.map((it) => (
            <LoafCard key={it.key} sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2, flexShrink: 0 }}>
                <Typography variant="h5" fontWeight={900} sx={{ color: "#fff" }}>{it.title}</Typography>
                <Button
                  onClick={(e) => handleDemoClick(e, it.url)}
                  size="small"
                  sx={{
                    background: "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    border: "1px solid rgba(121, 209, 195, 0.3)",
                    borderRadius: "12px",
                    color: "#79d1c3",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                    px: 2,
                    py: 0.5,
                    minWidth: "auto",
                    textTransform: "none",
                    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    '&:hover': {
                      background: "linear-gradient(135deg, rgba(121, 209, 195, 0.15) 0%, rgba(121, 209, 195, 0.08) 100%)",
                      border: "1px solid rgba(121, 209, 195, 0.5)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 8px 24px rgba(121, 209, 195, 0.2)",
                      color: "#ffffff",
                    },
                    '&:active': { transform: "translateY(0px)" },
                  }}
                >
                  <AutoAwesome sx={{ mr: 0.5, fontSize: "0.9rem" }} />
                  Demo
                </Button>
              </Box>
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
                <Box sx={{ flex: 1, overflowY: "auto", mb: 3 }}>
                  <ul style={{ margin: 0, paddingLeft: "1.2rem", lineHeight: 1.6, opacity: 0.9 }}>
                    {it.bullets.map((b, i) => (
                      <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginBottom: "12px" }}>
                        <Box sx={{ mt: "3px", flexShrink: 0 }}>{getDescriptionIcon(b, i)}</Box>
                        <span style={{ fontSize: "0.97rem" }}>{b}</span>
                      </li>
                    ))}
                  </ul>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", flexShrink: 0 }}>
                  {it.tech.map((t) => {
                    const color = getChipColor(t);
                    return (
                      <Chip
                        key={t}
                        label={t}
                        size="small"
                        sx={{
                          backgroundColor: `${color}20`,
                          border: `1px solid ${color}60`,
                          color: color,
                          fontWeight: 600,
                          fontSize: "0.75rem",
                          '&:hover': { backgroundColor: `${color}30`, transform: "scale(1.02)" },
                        }}
                      />
                    );
                  })}
                </Box>
              </Box>
            </LoafCard>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
